import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
	apiKey: "AIzaSyBB01GQymUx5NNVt7lNjJOfuh1nGD6CEls",
	authDomain: "numerys-app.firebaseapp.com",
	projectId: "numerys-app",
	storageBucket: "numerys-app.firebasestorage.app",
	messagingSenderId: "80861699661",
	appId: "1:80861699661:web:787058e7e5c23481dd4604",
	measurementId: "G-49EMP935EV",
};

const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west1");
